import * as React from 'react'
import Icon from '../Icon/Icon'

interface IIddleMessageProps {
  iddleMessageLabel: string
}

const IddleMessage: React.FC<IIddleMessageProps> = ({ iddleMessageLabel }) => {
  return (
    <div className="IddleMessage">
      <Icon name="iddle" />
      <p className="IddleMessage__label">{iddleMessageLabel}</p>
    </div>
  )
}

export default IddleMessage



// WEBPACK FOOTER //
// ./src/components/IddleMessage/IddleMessage.tsx